import { Router } from "../router";

export const router = new Router<any>();

router.on("deploy_log", (data, ctx) => {
    ctx.deploy.addLog(data.content);
});
